// export const getFileIcon = (fileName: string) => {
//     const extension = fileName.split('.').pop()?.toLowerCase();

//     if (extension === 'pdf') {
//         return (
//             <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-red-500">
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M14 2v6h6" />
//             </svg>
//         );
//     }

//     if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'bmp', 'ico', 'tiff', 'tif', 'avif', 'heic', 'heif'].includes(extension ?? '')) {
//         return (
//             <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-purple-500">
//                 <rect x="3" y="3" width="18" height="18" rx="2" />
//                 <circle cx="8.5" cy="8.5" r="1.5" />
//                 <path strokeLinecap="round" strokeLinejoin="round" d="m21 15-5-5L5 21" />
//             </svg>
//         );
//     }

//     if (['doc', 'docx', 'odt', 'rtf', 'pages'].includes(extension ?? '')) {
//         return (
//             <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-blue-500">
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M14 2v6h6" />
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M8 13h8M8 17h5" />
//             </svg>
//         );
//     }

//     if (['xls', 'xlsx', 'xlsm', 'csv', 'ods', 'numbers'].includes(extension ?? '')) {
//         return (
//             <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-green-600">
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M14 2v6h6" />
//                 <path strokeLinecap="round" strokeLinejoin="round" d="m8 13 4 4m0-4-4 4m7-4h1m-1 4h1" />
//             </svg>
//         );
//     }

//     if (['ppt', 'pptx', 'odp', 'key'].includes(extension ?? '')) {
//         return (
//             <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-orange-500">
//                 <rect x="3" y="4" width="18" height="14" rx="2" />
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M8 21h8M12 18v3M8 9h3a2 2 0 1 1 0 4H8V9Zm0 0v6" />
//             </svg>
//         );
//     }

//     if (['zip', 'rar', '7z', 'tar', 'gz', 'bz2', 'xz'].includes(extension ?? '')) {
//         return (
//             <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-yellow-600">
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M7 3h10v18H7z" />
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M10 3v3h4V3M10 9h4M10 12h4M10 15h4" />
//             </svg>
//         );
//     }

//     if (['txt', 'md', 'log', 'json', 'xml', 'yaml', 'yml', 'ini', 'cfg'].includes(extension ?? '')) {
//         return (
//             <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-gray-500">
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M14 2v6h6M8 13h8M8 17h6" />
//             </svg>
//         );
//     }

//     if (['js', 'jsx', 'ts', 'tsx', 'html', 'css', 'scss', 'sass', 'less', 'php', 'py', 'java', 'c', 'cpp', 'cs', 'sql', 'sh', 'bat'].includes(extension ?? '')) {
//         return (
//             <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-cyan-600">
//                 <path strokeLinecap="round" strokeLinejoin="round" d="m8 8-4 4 4 4M16 8l4 4-4 4M14 5l-4 14" />
//             </svg>
//         );
//     }

//     if (['mp3', 'wav', 'ogg', 'm4a', 'aac', 'flac', 'wma'].includes(extension ?? '')) {
//         return (
//             <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-pink-500">
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M9 18V5l10-2v13" />
//                 <circle cx="6" cy="18" r="3" />
//                 <circle cx="16" cy="16" r="3" />
//             </svg>
//         );
//     }

//     if (['mp4', 'webm', 'mov', 'avi', 'mkv', 'wmv', 'flv', 'm4v'].includes(extension ?? '')) {
//         return (
//             <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-indigo-500">
//                 <rect x="3" y="5" width="18" height="14" rx="2" />
//                 <path strokeLinecap="round" strokeLinejoin="round" d="m10 9 5 3-5 3V9Z" />
//             </svg>
//         );
//     }

//     return (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-[#186cb2]">
//             <path strokeLinecap="round" strokeLinejoin="round" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
//             <path strokeLinecap="round" strokeLinejoin="round" d="M14 2v6h6" />
//         </svg>
//     );
// };

import React from 'react';

const IMAGE_EXTENSIONS = [
    'png',
    'jpg',
    'jpeg',
    'gif',
    'webp',
    'svg',
    'bmp',
    'ico',
    'tiff',
    'tif',
    'avif',
    'heic',
    'heif',
];

const DOCUMENT_EXTENSIONS = [
    'doc',
    'docx',
    'odt',
    'rtf',
    'pages',
];

const SPREADSHEET_EXTENSIONS = [
    'xls',
    'xlsx',
    'xlsm',
    'csv',
    'ods',
    'numbers',
];

const PRESENTATION_EXTENSIONS = [
    'ppt',
    'pptx',
    'odp',
    'key',
];

const ARCHIVE_EXTENSIONS = [
    'zip',
    'rar',
    '7z',
    'tar',
    'gz',
    'bz2',
    'xz',
];

const TEXT_EXTENSIONS = [
    'txt',
    'md',
    'log',
    'json',
    'xml',
    'yaml',
    'yml',
    'ini',
    'cfg',
];

const CODE_EXTENSIONS = [
    'js',
    'jsx',
    'ts',
    'tsx',
    'html',
    'css',
    'scss',
    'sass',
    'less',
    'php',
    'py',
    'java',
    'c',
    'cpp',
    'cs',
    'sql',
    'sh',
    'bat',
];

const AUDIO_EXTENSIONS = [
    'mp3',
    'wav',
    'ogg',
    'm4a',
    'aac',
    'flac',
    'wma',
];

const VIDEO_EXTENSIONS = [
    'mp4',
    'webm',
    'mov',
    'avi',
    'mkv',
    'wmv',
    'flv',
    'm4v',
];

export const getFileExtension = (fileName: string) => {
    return fileName.split('.').pop()?.toLowerCase() ?? '';
};

export const isImageFile = (fileName: string) => {
    return IMAGE_EXTENSIONS.includes(getFileExtension(fileName));
};

export const getFileIcon = (fileName: string) => {
    const extension = getFileExtension(fileName);

    if (extension === 'pdf') {
        return (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-red-500">
                <path strokeLinecap="round" strokeLinejoin="round" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M14 2v6h6" />
            </svg>
        );
    }

    if (IMAGE_EXTENSIONS.includes(extension)) {
        return (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-purple-500">
                <rect x="3" y="3" width="18" height="18" rx="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <path strokeLinecap="round" strokeLinejoin="round" d="m21 15-5-5L5 21" />
            </svg>
        );
    }

    if (DOCUMENT_EXTENSIONS.includes(extension)) {
        return (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-blue-500">
                <path strokeLinecap="round" strokeLinejoin="round" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M14 2v6h6" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M8 13h8M8 17h5" />
            </svg>
        );
    }

    if (SPREADSHEET_EXTENSIONS.includes(extension)) {
        return (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-green-600">
                <path strokeLinecap="round" strokeLinejoin="round" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M14 2v6h6" />
                <path strokeLinecap="round" strokeLinejoin="round" d="m8 13 4 4m0-4-4 4m7-4h1m-1 4h1" />
            </svg>
        );
    }

    if (PRESENTATION_EXTENSIONS.includes(extension)) {
        return (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-orange-500">
                <rect x="3" y="4" width="18" height="14" rx="2" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M8 21h8M12 18v3M8 9h3a2 2 0 1 1 0 4H8V9Zm0 0v6" />
            </svg>
        );
    }

    if (ARCHIVE_EXTENSIONS.includes(extension)) {
        return (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-yellow-600">
                <path strokeLinecap="round" strokeLinejoin="round" d="M7 3h10v18H7z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M10 3v3h4V3M10 9h4M10 12h4M10 15h4" />
            </svg>
        );
    }

    if (TEXT_EXTENSIONS.includes(extension)) {
        return (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-gray-500">
                <path strokeLinecap="round" strokeLinejoin="round" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M14 2v6h6M8 13h8M8 17h6" />
            </svg>
        );
    }

    if (CODE_EXTENSIONS.includes(extension)) {
        return (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-cyan-600">
                <path strokeLinecap="round" strokeLinejoin="round" d="m8 8-4 4 4 4M16 8l4 4-4 4M14 5l-4 14" />
            </svg>
        );
    }

    if (AUDIO_EXTENSIONS.includes(extension)) {
        return (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-pink-500">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 18V5l10-2v13" />
                <circle cx="6" cy="18" r="3" />
                <circle cx="16" cy="16" r="3" />
            </svg>
        );
    }

    if (VIDEO_EXTENSIONS.includes(extension)) {
        return (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-indigo-500">
                <rect x="3" y="5" width="18" height="14" rx="2" />
                <path strokeLinecap="round" strokeLinejoin="round" d="m10 9 5 3-5 3V9Z" />
            </svg>
        );
    }

    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 text-[#186cb2]">
            <path strokeLinecap="round" strokeLinejoin="round" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M14 2v6h6" />
        </svg>
    );
};